import { ReactComponent as FileDownload } from "../../../../assets/icons/fileDownload.svg";

const FileDownloadIcon = (props) => {
  return (
    <FileDownload
      style={{ cursor: "pointer" }}
      fill={props.styleColor ? props.styleColor : "#A8A8A8"}
    />
  );
};

export default FileDownloadIcon;
